import { get, jsonp } from 'utils/request';
import { isEmpty } from 'lodash';
import { Icon } from '@ali/aps';
import config from '$config';
import activityMeta from 'utils/activityMeta';
const { templateId } = activityMeta;

export const Content = ({ type, title, text }) => {
  return (
    <div>
      <div className="notification-header">
        <Icon className="notification-icon" type={type} />
        <div className="notification-title">{title}</div>
      </div>
      <div className="notification-text">{text}</div>
      <div className="notification-background">
        {/* <img className="left" src="https://img.alicdn.com/tfs/TB1qPThiwHqK1RjSZFgXXa7JXXa-199-182.png" /> */}
        <img className="right" src="https://img.alicdn.com/tfs/TB1fl9it3HqK1RjSZFgXXa7JXXa-900-164.png" />
        <img className="top" src="https://img.alicdn.com/tfs/TB1WMeft9zqK1RjSZPcXXbTepXa-440-176.png" />
      </div>
    </div>
  );
};

let codeMap = {};

const generateCodeMap = codes => {
  codes.forEach(it => {
    codeMap[it.code] = {
      content: <Content type={it.icon} title={it.title} text={it.text} />,
      buttons: it.buttons.split(','),
    };
  });
};

export async function fetchCodeMap() {
  try {
    if (isEmpty(codeMap)) {
      const result = await get('https://query.aliyun.com/rest/groupBuying.codeMap');
      generateCodeMap(result.data);
    }
    return codeMap;
  } catch (error) {
    console.error(error);
  }
}

export async function fetchScrollNotice() {
  try {
    const result = await jsonp(`${config.DASHI_ENDPOINT}/api/ambassador/queryPrizeList`, {
      templateId,
    });
    return result.data || {};
  } catch (error) {
    console.log(error);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/NotificationService.js